export const USER_DEFAULT_VALUE = {
  userGroup: {
    userGroup: "",
    error: false,
  },
  title: {
    title: "",
    error: false,
  },
  firstName: {
    firstName: "",
    error: false,
  },
  lastName: {
    lastName: "",
    error: false,
  },
  qualifications: "",
  position: {
    position: "",
    error: false,
  },
  contactNo: "",
  email: {
    email: "",
    error: false,
  },
  address1: "",
  address2: "",
  active: true,
  userName: {
    userName: "",
    error: false,
  },
  password: {
    password: "",
    error: false,
  },
  confirmPassword: {
    confirmPassword: "",
    error: false,
  },
  id: "",
};
